import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useContractPage } from '../../../../../../../../hooks/requests/pages/use-contract-page';
import { useCustomersOverviews } from '../../../../../../../../hooks/requests/use-customers-overviews/use-customers-overviews';
import { useValidatedParams } from '../../../../../../../../hooks/use-validated-params';
import { useVyNavigate } from '../../../../../../../../hooks/use-vy-navigate';
import { PLAN_CREATE_ROUTE } from '../../../../../../../../router/routing-consts';
import {
  ContractDateSection,
  CustomerSelectionSection,
} from '../../../../../../../plans/GetStartedPlansPage/components/CreateContractForm';
import type { AssignCustomerForm } from '../../../../../../../plans/GetStartedPlansPage/types/assign-customer-dialog-form-types/assign-customer-form-schema';
import { AssignCustomerFormSchema } from '../../../../../../../plans/GetStartedPlansPage/types/assign-customer-dialog-form-types/assign-customer-form-schema';

export const RenewContractNewTermsStepCreate: React.FC = () => {
  const { contractId } = useValidatedParams<['contractId']>('contractId');

  const { data } = useContractPage(contractId, {
    suspense: false,
  });

  const navigate = useVyNavigate();
  const methods = useForm<AssignCustomerForm>({
    resolver: zodResolver(AssignCustomerFormSchema),
  });
  const { data: customerOverviewResponse } = useCustomersOverviews();
  const { customers = [] } = customerOverviewResponse ?? {};

  useEffect(() => {
    if (isNotNullOrUndefined(data?.contractPageData.contract.customer.id)) {
      methods.setValue('customerId', data.contractPageData.contract.customer.id);
    }
  }, [data?.contractPageData.contract.customer.id]);

  const onSubmit = methods.handleSubmit(({ customerId, startDate }) => {
    navigate(PLAN_CREATE_ROUTE, {
      state: {
        customerId,
        startDate,
      },
    });
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <Stack direction="column" sx={{
          gap: "16px"
        }}>
          <CustomerSelectionSection customers={customers} />
          <ContractDateSection />
        </Stack>
      </form>
    </FormProvider>
  );
};
